/** Sekunden → „HH:MM:SS" (für den laufenden Timer). */
export function formatDuration(totalSeconds: number): string {
  const secs = Math.max(0, Math.floor(totalSeconds));
  const h = Math.floor(secs / 3600);
  const m = Math.floor((secs % 3600) / 60);
  const s = secs % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${pad(h)}:${pad(m)}:${pad(s)}`;
}

/** Vergangene Sekunden seit einem ISO-Startzeitpunkt bis `now`. */
export function elapsedSeconds(startIso: string, now: number = Date.now()): number {
  return Math.max(0, Math.floor((now - new Date(startIso).getTime()) / 1000));
}

const hoursFormat = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2 });

/** Dezimalstunden für die Anzeige (z. B. 1,5 h). */
export function formatHours(hours: number): string {
  return `${hoursFormat.format(hours)} h`;
}
